import {Button, Flex, Popover, Radio, Typography} from "antd";
import {GrCircleQuestion} from "react-icons/gr";
import React, {useEffect} from "react";
import {resultStore} from "../../../store/admissions/admissionStore";
import UploadDoc from "../component/UploadDoc";
import {stepsStore} from "../../../store/admissions/stepperStore";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {userStore} from "../../../store/store";

const style: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
};

export default function Step6() {
    const {stepsData, setStepsData} = stepsStore();
    const {xl} = useBreakpoint()
    const {result, setResult} = resultStore();
    const {user, setUser} = userStore();

    useEffect(() => {
        if (result.kindsLevelFormation === "000000008" || result.kindsLevelFormation === "000000003") {
            setStepsData({...stepsData, nextStep: true, backStep: stepsData.backStep + 1})
            setResult({
                ...result,
                education: "3"
            })
        }
        if (result.kindsLevelFormation === "СПО9КЛАССОВ") {
            setStepsData({...stepsData, nextStep: true, backStep: stepsData.backStep + 1})
            setResult({
                ...result,
                education: "0"
            })
        }
    }, []);

    function UploadItem(props: any) {
        return (
            <Flex gap={24} style={{width: "100%"}}>
                <Flex style={{width: "50%"}} justify={"flex-end"} align={"center"}>
                    <Typography.Text>{props.title}</Typography.Text>
                </Flex>
                <Flex style={{width: "50%"}} align={"center"} justify={"flex-start"} gap={16}>
                    <UploadDoc id={props.title} onFileChange={() => {
                    }}/>
                    <Popover title={props.help}
                             placement={"right"}
                             trigger="hover">
                        <Button type={"text"} icon={<GrCircleQuestion/>}/>
                    </Popover>
                </Flex>
            </Flex>
        )
    }

    const getOptions = () => {

        const options = [
            {
                value: "1",
                label: "Среднее общее - окончена школа, лицей или гимназия"
            },
            {
                value: "2",
                label: "Среднее профессиональное - окончен колледж, училище или техникум"
            },
            {
                value: "3",
                label: "Высшее - оконченно высшее учебное заведение"
            }
        ]

        if (result.kindsLevelFormation === "СПО9КЛАССОВ") {
            options.push({
                value: "0",
                label: "Основное общее - окончено 9 классов"
            })
        }

        return options.sort((a: any, b: any) => a.value > b.value ? 1 : -1)
    }

    return (
        <Flex vertical style={{width: '100%'}} justify={"center"} align={"center"} gap={24}>
            <Typography.Text strong style={{fontSize: 20}}>Информация про мое образование</Typography.Text>
            <Typography.Text>Укажите образование, которое у Вас есть:</Typography.Text>
            <Flex vertical>
                <Radio.Group
                    style={style}
                    disabled={result.kindsLevelFormation === "000000008" || result.kindsLevelFormation === "000000003" || result.kindsLevelFormation === "СПО9КЛАССОВ"}
                    defaultValue={() => {
                        if (result.kindsLevelFormation === "000000008" || result.kindsLevelFormation === "000000003") {
                            return "3"
                        } else if (result.kindsLevelFormation === "СПО9КЛАССОВ") {
                            return "0"
                        }
                    }}
                    onChange={(value) => {
                        setResult({
                            ...result,
                            education: value.target.value
                        })
                        setStepsData({...stepsData, nextStep: true})
                    }}
                    options={getOptions()}
                />
            </Flex>
            <Typography.Text style={{fontSize: "20px"}} strong>Загрузите документы о текущем
                образовании</Typography.Text>
            <Typography.Text>Можно загрузить файлы формата .pdf, .jpg, .jpeg, .png и .zip размером до
                5мб</Typography.Text>
            <Flex
                style={{width: xl ? "70%" : "100%"}}
                justify={"center"}
                align={"center"}
                vertical={true}
                gap={16}
            >
                {user.country === "643" ?
                    <>
                        <UploadItem title={"Лицевой разворот диплома/аттестата"}
                                    help={"Лицевой разворо диплома/аттестата"}/>
                        <UploadItem title={"Приложение к диплому/аттестату (лицевой разворот)"}
                                    help={"Приложение к диплому/аттестату (лицевой разворот)"}/>
                        <UploadItem title={"Приложение к диплому/аттестату (задний разворот)"}
                                    help={"Приложение к диплому/аттестату (задний разворот)"}/>
                    </>
                    :
                    <>
                        <UploadItem title={"Документ об образовании"}
                                  help={"Для иностранных документов, необходимо загрузить копии нотариально-заверенного перевода на русский язык"}/>
                        <UploadItem title={"Приложение к документу об образовании"}
                                    help={"Для иностранных документов, необходимо загрузить копии нотариально-заверенного перевода на русский язык"}/>
                    </>
                }
            </Flex>
        </Flex>
    )
}